import { CSSProperties } from 'react';
import { useOrganizationConfig } from 'core/stores/hooks/useOrganizationConfig';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { S3Bucket } from 'core/services/amplify/config/constants';
import { PoppIcon } from 'common/icons/PoppIcon';
import { useAmplifyFileURL } from 'core/services/amplify/storage/useAmplifyFileURL';

const imageStyle: CSSProperties = {
  height: '60px',
  width: 'auto',
  objectFit: 'contain'
};

export const MainLogo = () => {
  const organizationConfig = useOrganizationConfig();
  const organization = useOrganization();

  const { url } = useAmplifyFileURL({
    bucket: S3Bucket.PUBLIC,
    path: organization?.logoS3Key
  });

  if (organizationConfig?.whiteLabelingEnabled && organization?.logoS3Key) {
    return <img src={url?.href} alt="logo" style={imageStyle} />;
  }

  return <PoppIcon />;
};
